module.exports = __webpack_public_path__ + "img/smart.e8ef3d2f.svg";